import React from "react";
import PropTypes from "prop-types";
import { useBaseMediaUrls } from "../../hooks/useBaseMediaUrls";
import { getImageUrl, transformations } from "../../util/get-url-utils";
import { MediaImage, MediaCopyright, MediaTitle } from "./styled";

const InlineImage = ({ title, publicId, copyright }) => {
  const cloudinaryUrl = useBaseMediaUrls("images");

  return (
    <>
      {title && (
        <MediaTitle
          element="p"
          fontSize="md"
          marginBottom="xs"
          color="gray800"
          fontWeight="semibold"
        >
          {title}
        </MediaTitle>
      )}
      <MediaImage
        alt={title}
        src={getImageUrl(publicId, cloudinaryUrl, transformations.none)}
      />
      {copyright && (
        <MediaCopyright data-testid="inline-media-copyright">
          {copyright}
        </MediaCopyright>
      )}
    </>
  );
};

InlineImage.propTypes = {
  title: PropTypes.string,
  copyright: PropTypes.string,
  publicId: PropTypes.string.isRequired,
};
InlineImage.displayName = "InlineImage";

export default InlineImage;
